<template>
  <section class="page-user-content">
    <course-dashboard-top/>
    <div class="user-content">
      <div class="container h-100 d-flex align-items-end">
        <div class="tab-nav-master">
          <div class="tab-scroll text-center d-flex flex-row justify-content-center">
            <!-- <router-link :to="'/course-description/'+courseId" class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14" exact> -->
            <router-link
              :to="linkCourses+'/course-description/'"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
              exact
            >توضیحات دوره</router-link>
            <router-link
              :to="linkCourses+'/list-content/'"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
            >محتوای آموزش</router-link>
            <router-link
              :to="linkCourses+'/discuss/'"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
            >تابلو اعلانات - پرسش و پاسخ</router-link>
            <router-link
              :to="linkCourses+'/comment/'"
              class="d-inlin-block px-md-3 py-md-2 px-1 py-1 font-14"
            >نظرات</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="course-dashboard-middel mb-5">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import courseDashboardTop from 'cp/course-dashboard-top.vue'
export default {
  components: {
    courseDashboardTop
  },
  name: 'page-user-content',
  created() {
    this.checkEnroll()
  },
  computed: {
    courseId() {
      return this.$route.params.id
    }
  },
  destroyed() {
    this.$store.commit('courses/clear')
  },
  methods: {
    async checkEnroll() {
      this.isLoading = true
      try {
        let { data } = await axios.post('/enroll/check', { course_id: this.courseId })
        if (!data.enroll) {
          this.$root.showWarnMsg({
            message: 'شما مخاطب دوره نیستید ...'
          })
          this.$router.push('/')
          return
        }
        if (data.state != 200) {
          return
        }
        this.getInfo()
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
    async getInfo() {
      // this.$store.dispatch('courses/getInstractor', this.courseId)
      await this.$store.dispatch('courses/getCourseDetail', { id: this.courseId })
      this.$store.dispatch('courses/getGoals', { id: this.courseId })
      this.$store.dispatch('courses/courseMsg', { id: this.courseId })
      this.isLoading = false
    }
  }
}
</script>
<style lang="less">
@import (reference) "../assets/css/variable.less";
.page-user-content {
  .box-clear;
  .user-content {
    background: #fff;
    width: 100%;
    .BoxShadowHelper(@level: 1);
    .tab-nav-master {
      overflow: hidden;
      overflow-x: auto;
      overflow-y: hidden;
      z-index: 2;
      a {
        min-width: 160px;
        background: #fff;
        color: @primaryTextColor;
        line-height: 45px;
        padding: 10px 0;
        .line-hover;
      }
      .router-link-active {
        .line;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/content.vue